import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { PlatformGroupRoleDto } from 'projects/shared/src/lib/models/PlatformGroupRoleDto';
import { TenantDto, TenantGroupRoleDto } from 'projects/shared/src/lib/models/TenantDto';
import { UserDto, UsersDto } from 'projects/shared/src/lib/models/User';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
//import { PlatformGroupRoleService } from 'projects/shared/src/lib/services/platform-group-role.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { debounceTime, finalize, switchMap, tap } from 'rxjs';
import { SelectUserpermissionDialogComponent } from '../select-userpermission-dialog/select-userpermission-dialog/select-userpermission-dialog.component';
import { ProjectGroupRoleUser, SelectUserpermissionsResult } from 'projects/shared/src/lib/models/SquirrelRoles';
import { SelectData } from 'projects/shared/src/lib/models/SelectData';

@Component({
  selector: 'add-user-dialog',
  templateUrl: './add-user-dialog.component.html',
  styleUrls: ['./add-user-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddUserDialogComponent implements OnInit {

  userForm!: FormGroup;
  titleAlert: string = 'This field is required';
  @Input() labelPosition!: 'before' | 'after';

  //groupRoles:TenantGroupRoleDto[] = [];
  users:UserDto[] = [];
  copyUserName:string = "";
  copyUserId:string = "00000000-0000-0000-0000-000000000000";
  filter!: GenericFilter;
  _isadmin!:string;
  isLoading = false;
  _userSelected = false;
  inclTGR = false;
  showInclTGRInfo = false;

  //totalRecords = 0;
  currentPage = 1;
  pageSize = 10000;

  selectUserpermissionResult: SelectUserpermissionsResult = new SelectUserpermissionsResult();

  constructor(
    private formBuilder: FormBuilder,
    public _dialogRef: MatDialogRef<AddUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, // flag: vorher kein User vorhanden (wird nicht verwendet)
    public translate: TranslateService,
    private notificationService: NotificationService,
    private tenantService: TenantService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {

    // this.filter = new GenericFilter();
    // this.tenantService.getTenantGroupRoles(this.tenantService.currentTenantName, this.filter).subscribe({
    //    next:(groupRoleDtos:any) => { 
    //     // console.log("------> tenantGroupRoles: ", groupRoleDtos)
    //     this.groupRoles = groupRoleDtos;
    //   }
    // })
    this.createUserForm();
    this.searchTenantUser();
  }

  createUserForm() {
    let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    let roles:TenantGroupRoleDto[] = [];
    // let users:UsersDto[] = [];
    this.userForm = this.formBuilder.group({
      email: [null, [Validators.required, Validators.pattern(emailregex)]],
      emailConfirmed: [false],
      userName: ['NOTCONFIRMED'],
      firstName:[null],
      lastName:[null],
      phoneNumber: [null],
      phonenumberConfirmed: [false],
      //  lockoutEnabled: [false],
      twoFactorEnabled: [false],
      // accessFailedCount: [0],
      // lockoutEnd: [null],
      userRoles:[roles],
      // tenant:[null],
      


      // userRoles:[roles],
      // users:[users]
      copyUser:[null],
      inclTGR: this.inclTGR
    });

  }

  searchTenantUser() {
    console.log("---------> add-user-dialog: search tenant user")
    // es kann sein, dass diese Aktion vom Admin in SM ausgeführt wird, dann ist der temporäre Tenant zu nehmen
    // der temporäre Tenant wird gesetzt, wenn der Admin für einen Tenant eine Aktion ausführt,
    // aber auch, wenn man in den Tenant gewechselt hat. Dann ist der temporäre Tenant gleich dem current Tenant
    let searchText="";
    this.tenantService.loadTenantUsers(this.tenantService.tempTenantName, searchText, this.currentPage, this.pageSize).subscribe({
      next: (userDto: UserDto[]) => {
        this.users = userDto.sort((a, b) => (a.last_Name > b.last_Name) ? 1 : ((b.last_Name > a.last_Name) ? -1 : 0));
//        this.rowData = this.userData.sort((a, b) => (a.lastName > b.lastName) ? 1 : ((b.lastName > a.lastName) ? -1 : 0));

        if(this.users.length > 0){
          //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["RETRIEVEDUSERS"]} `);
        }
        else{
          //console.log("No users found")
          this.notificationService.info(`${this.translate.data["INFO"]}`, "Keine weiteren Benutzer zur Suche vorhanden!");
        }        
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["RETRIEVEUSERSERROR"]}`)
    });

    this.userForm.get('copyUser')?.valueChanges
      .pipe(debounceTime(300),
        tap(() => this.isLoading = true),
        switchMap((value: any) => this.tenantService.loadTenantUsers(this.tenantService.tempTenantName, value, this.currentPage, this.pageSize)
          .pipe(finalize(() => this.isLoading = false))))
      .subscribe({
        next: (userDto: UserDto[]) => {
          this.users = userDto;
          //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["USERFOUND"]} `);
        },
        error: (error: any) => this.notificationService.error(`${this.translate.data["INFO"]}`, `${this.translate.data["USERFOUNDERROR"]}`)
      });
  }

  displayFn(user: any) {
    console.log("displayFn: user = ", user)
    if (user) { return user.userName; }
  }

  onChange() {
    this.inclTGR = !this.inclTGR;
  }

  optionSelected(event: any) {
    console.log("event:", event);
    console.log("userId:", event.option.value.id);
    // this.projectGroupRoleUser.roleId = this.data.roleId;
    // this.projectGroupRoleUser.userId = event.option.value.id;
    // this.projectGroupRoleUser.projectId = this.data.projectId;
    // this.projectGroupRoleUser.roleName = this.data.roleName;
    // this.projectGroupRoleUser.userName = (event.option.value.userName != "")?event.option.value.userName:event.option.value.email;
    this.copyUserName = (event.option.value.emailConfirmed)?event.option.value.userName:event.option.value.email;
    this.copyUserId = event.option.value.id;
    // this.projectGroupRoleUser.tenantId = event.option.tenantId;
    this._userSelected = true;

    this.tenantService.getUserTenantGroupRoles(this.tenantService.tempTenantName, this.copyUserId, new GenericFilter()).subscribe({
      next: (grouproles) => {
        if (grouproles.length > 0) {
          this.showInclTGRInfo = true;
        }
      },

      error: (error: any) => {
      this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["RETRIEVEUSERROLESERROR"]}`)
            }
    });

  }

  selectUserPermission() {
    let selectData = new SelectData();
    selectData.action = "selectForUser";
    selectData.tenantName = this.tenantService.tempTenantName;
    selectData.userId = this.copyUserId;
    // const dialogRef = this.dialog.open(SelectUserpermissionDialogComponent, { height: '800px', width: '800px', data: this.copyUserId, position: { top: '100px', left: '1200px' } });
    const dialogRef = this.dialog.open(SelectUserpermissionDialogComponent, { height: '600px', width: '800px', data: selectData});
    dialogRef.afterClosed().subscribe((result: any) => { 

      console.log("-----> add-user-dialog: Proj-Role Id-Pairs = ", result)
      this.selectUserpermissionResult.projRolePairs = result;
      if (result !== undefined) {
        this.add();
        //this._dialogRef.close();
      } else { //Abbruch
        this._userSelected = false;
        this.copyUserName = "";
        this.copyUserId = "00000000-0000-0000-0000-000000000000";
        this.userForm.patchValue({copyUser: ""});
        this.showInclTGRInfo = false;
      }
    },
    //error
    );
  }


  cancel() {
    this._dialogRef.close();
  }
  isFormValid() {
    return this.userForm.valid;
  }

  add() {
    if (this.userForm.valid) {
      let newUserData = {userDto: this.userForm.value};
      newUserData.userDto.inclTGR = this.inclTGR;
      console.log("=========> user form value/userData", newUserData)
      this.selectUserpermissionResult.userData = newUserData;
      this._dialogRef.close(this.selectUserpermissionResult);
    }
    else{
      this.notificationService.warning(`${this.translate.data["WARN"]}`, `${this.translate.data["USERREQUIREDFIELDS"]}`);
    }
  }

  getErrorEmail() {
    return this.userForm.get('email')?.hasError('required') ? `${this.translate.data["ERRORALERT"]}` :
      this.userForm.get('email')?.hasError('pattern') ? `${this.translate.data["INVALIDEMAIL"]}` :
        this.userForm.get('email')?.hasError('alreadyInUse') ? `${this.translate.data["ALREADYTAKENEMAIL"]}` : '';
  }

  // getErrorPassword() {
  //   return this.userForm.get('password')?.hasError('required') ? 'Field is required (at least eight characters, one uppercase letter and one number)' :
  //     this.userForm.get('password')?.hasError('requirements') ? 'Password needs to be at least eight characters, one uppercase letter and one number' : '';
  // }

  public errorHandling = (control: string, error: string) => {
    return this.userForm.controls[control].hasError(error);
  }

}

